import { useMutation, useQueryClient } from '@tanstack/react-query';
import { restorePartnerGroupChannel } from '../services/partnerGroupChannel';
import { partnerGroupChannelQueryKeys } from './use-partner-group-channel-query';

export const useRestorePartnerGroupChannelMutation = (options = {}) => {
  const queryClient = useQueryClient();
  const { onSuccess, onError, ...restOptions } = options;

  return useMutation({
    mutationFn: async () => {
      const result = await restorePartnerGroupChannel();

      if (!result.success) {
        throw new Error(result.message || 'Failed to restore community channel');
      }

      return result;
    },
    onSuccess: async (data, variables, context) => {
      await queryClient.invalidateQueries({ queryKey: partnerGroupChannelQueryKeys.all });
      await onSuccess?.(data, variables, context);
    },
    onError: (error, variables, context) => {
      onError?.(error, variables, context);
    },
    ...restOptions,
  });
};
